import { merge } from "lodash";

import { UPDATE_MODAL } from "./modal.constants";

export default function modal(state = {}, action) {
  switch (action.type) {
    case UPDATE_MODAL:
      return merge({}, state, action.payload);
    default:
      return state;
  }
}
